/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
} from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../src/store/userSilce";

// Helper
function getFullName(params) {
  return `${params.row.mem_rank || ""} ${params.row.mem_fname || ""} ${
    params.row.mem_lname || ""
  }`;
}

// Column Configuration
const useResponsiveColumns = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  return [
    {
      field: "id",
      headerName: "ลำดับ",
      width: isXs ? 60 : 100,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        params.api.getRowIndex(params.row.testresultcode) + 1,
    },
    {
      field: "pers_id",
      headerName: "เลขประจำตัว",
      headerAlign: "center",
      width: isXs ? 150 : 300,
      align: "center",
      hide: isXs,
    },
    {
      field: "mem_affiliation",
      headerName: "หน่วยงาน",
      headerAlign: "center",
      width: isXs ? 180 : 300,
      align: "center",
    },
    {
      field: "Fullname",
      headerName: "ยศ ชื่อ นามสกุล",
      headerAlign: "left",
      width: isXs ? 200 : 450,
      align: "left",
      valueGetter: getFullName,
    },
    {
      field: "management",
      headerName: "การจัดการ",
      headerAlign: "center",
      width: isXs ? 180 : 250,
      align: "center",
      renderCell: (params) => (
        <Link
          to="/ContentViewTestScores"
          style={{ textDecoration: "none" }}
          state={{
            pers_id: params.row.pers_id,
            mem_rank: params.row.mem_rank,
            mem_fname: params.row.mem_fname,
            mem_lname: params.row.mem_lname,
            testresvcode: params.row.testresvcode,
            mem_affiliation: params.row["mem_affiliation"],
          }}
        >
          <Button variant="contained" size={isXs ? "small" : "medium"}>
            ดูผลคะแนน
          </Button>
        </Link>
      ),
    },
  ];
};

// Quick Search
function QuickSearchToolbar() {
  return (
    <Box sx={{ p: 0.5, pb: 0 }}>
      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) =>
          searchInput
            .split(",")
            .map((value) => value.trim())
            .filter((value) => value !== "")
        }
      />
    </Box>
  );
}

// Main Component
function ContentIndividualScores() {
  const [gettbtestresult, setgettbtestresult] = useState([]);
  const [gettbmemberinfo, setgettbmemberinfo] = useState([]);
  const [gettbtestreservation, setgettbtestreservation] = useState([]);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const token = user.token;
  const userRole = user.userRole;
  const USR02 = userRole[1].status;
  const orgname = user.orgname;
  const columns = useResponsiveColumns();

  // Fetch Data
  const fetchData = (url, setter) => {
    Axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}${url}`,
      headers: { authtoken: "bearer " + token },
    })
      .then((res) => {
        setTimeout(() => {
          setter(res.data);
          setLoading(false);
        }, 1000);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status === 401 || status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: status, txt: err.response.data },
          });
        }
        console.error("Fetch error:", err);
      });
  };

  useEffect(() => {
    fetchData("/gettbtestresult", setgettbtestresult);
    fetchData("/gettbmemberinfo", setgettbmemberinfo);
    fetchData("/gettbtestreservation", setgettbtestreservation);
  }, []);

  // Data Join
  const memberInfoMap = new Map();
  gettbmemberinfo.forEach((m) => memberInfoMap.set(m.meminfo_id, m));
  const joinedData = gettbtestresult
    .filter((r) => memberInfoMap.has(r.meminfo_id))
    .map((r) => ({ ...r, ...memberInfoMap.get(r.meminfo_id) }));

  const uniqueDataMap = new Map();
  joinedData.forEach((item) => {
    if (!uniqueDataMap.has(item.pers_id)) {
      uniqueDataMap.set(item.pers_id, item);
    }
  });
  const uniqueDataArray = Array.from(uniqueDataMap.values());
  const filteredData = uniqueDataArray.filter(
    (item) => item.mem_affiliation === orgname
  );

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            sx={{
              fontSize: { xs: "22px", sm: "28px", md: "35px", lg: "35px" },
              mb: 2,
            }}
          >
            ข้อมูลผลคะแนนการทดสอบ
          </Typography>
        </Grid>

        <Grid item>
          <Box display="flex" justifyContent="flex-start">
            <Link to="/PageTestScores" style={{ textDecoration: "none" }}>
              <Button
                sx={{
                  display: {
                    xs: "none", // ซ่อนบนโทรศัพท์
                    sm: "none", // ซ่อนบนแท็บเล็ตเล็ก
                    md: "flex", // แสดงบนหน้าจอกลางขึ้นไป
                  },
                }}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
              >
                ย้อนกลับ
              </Button>
            </Link>
          </Box>
        </Grid>

        <Grid item>
          <Box
            sx={{
              width: "100%",
              height: { xs: 500, sm: 600, md: 700 },
              mt: 2,
            }}
          >
            <DataGrid
              getRowId={(row) => row.testresultcode}
              rows={USR02 === "1" ? filteredData : uniqueDataArray}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[5]}
              loading={loading}
              components={{ Toolbar: QuickSearchToolbar }}
              initialState={{
                filter: {
                  filterModel: {
                    items: [],
                    quickFilterLogicOperator: GridLinkOperator.Or,
                  },
                },
              }}
              sx={{
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#ffffff",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#fafafa",
                },
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default ContentIndividualScores;
